import React, { Component } from "react";
import TableOffers from './components/TableOffers';
import { translate } from 'react-i18next';
import ModalMultipleRecords from './components/ModalMultipleRecords';
import ModalClearCaller from './components/ModalClearCaller';
import Notifications, {notify} from 'react-notify-toast';
import WaitingModal from '../generics/WaitingModal';
import SearchBar from '../generics/SearchBar';
import swal from 'sweetalert';
import $ from 'jquery';
import Help from '../generics/help';

import SvgIcon from 'react-icons-kit';
import {search} from 'react-icons-kit/icomoon/search';
import moment from 'moment';

window.$ = window.jQuery = require("jquery");
require('ms-signalr-client');
var Config = require('../../config');
var _hub;
var ChatProxy;
var ChatUrl = Config.default.apiGateway.short_url + "signalr";

class Offers extends Component {
  constructor(props, context) {
    super(props);
    this.getItems = this.getItems.bind(this);
    this.setNewValues = this.setNewValues.bind(this);
    this.newSingleRecord = this.newSingleRecord.bind(this);
    this.newMultipleRecord = this.newMultipleRecord.bind(this);
    this.createdRecord = this.createdRecord.bind(this);
    this.clearedCaller = this.clearedCaller.bind(this);
    this.selectFieldHandle = this.selectFieldHandle.bind(this);
    var aux_date = new Date();

    this.showAll = this.showAll.bind(this);
    this.clearList = this.clearList.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);


    //Definicion de variables
    var date = aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2);
    
    this.state = {
      isLoading: true,
      offers: [],
      start_date: date, //moment(date, "YYYY-MM-DD").format("DD/MM/YYYY"),
      end_date:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
      site:"any",
      sites:[],
      don_usr_llam:{},
      filter:"all",
      filterText:"",
      hubConnection:null,
      message:"",
      filters:[
        {
          label:"TODOS",
          key:"all"
        },
        {
          label:"CON PENDIENTES",
          key:"pendientes"
        },
        {
          label:"PENDIENTE SIGNOS VITALES",
          key:"sv"
        },
        {
          label:"PENDIENTE BIOMETRÍA HEMÁTICA",
          key:"biometrics"
        },
        {
          label:"PENDIENTE HISTORIA CLÍNICA",
          key:"clinic_history"
        },
        {
          label:"PENDIENTE EXTRACCIÓN",
          key:"extraction"
        }
      ],

      extracion_filter:"pending",

      search: "",
      allChecked:false,
      help_submenu:"",
      show_promotion:false,
      counters:{},
      no_caller:false,
    };
  }

  componentWillMount() {
      var search = this.props.match.url.replace('/', '');
      this.setState({
        search:search
      })

      if(sessionStorage.getItem('entity_type') !== 'BLOOD_BANK'){
        this.setState({no_caller:true});
      }

      if(this.props.location.pathname.indexOf('promotion') !== -1){
        this.setState({show_promotion:true, site:'all'});
      }
      
      this.getUsrLLam();

      var refresh = false;
      if(search === 'register' || search === 'vital_signs' || search === 'biometrics' || search === 'clinic_history' || 
        search === 'extractions' || search === 'offers'){
        refresh = true;
      }

      switch(search){
        case 'register':
          this.setState({help_submenu:"help_register"});
          break;
        case 'vital_signs':
          this.setState({help_submenu:"help_sv"});
          break;
        case 'biometrics':
          this.setState({help_submenu:"help_biometrics"});
          break;
        case 'clinic_history':
          this.setState({help_submenu:"help_hc"});
          break;
        case 'extractions':
          this.setState({help_submenu:"help_extractions"});
          break;
        case 'offers':
          this.setState({help_submenu:"help_sumary"});
          break;

      }
      //Actualizar listado por mensaje del servidor
      _hub = $.hubConnection(ChatUrl, {
        useDefaultPath: false
      });

      ChatProxy = _hub.createHubProxy('ChatHub');
      ChatProxy.setNewValues = this.setNewValues;

      ChatProxy.on("addNewMessageToPage", function(name, message, counters, listOffers, listSV,listBiometrics,listExtractions,listAllSummary,listHC,today) {
        if(message === "refresh" && name.toString() === sessionStorage.getItem('health_facilities_id').toString()){
          this.setNewValues(counters,listOffers,listSV,listBiometrics,listExtractions,listAllSummary,listHC, moment(today).format('YYYY-MM-DD'));
          console.log('llamando desde '+search);
        }
      });

      _hub.start()
      .done(function() {
        console.log("Connected to Signalr Server");
      })
      .fail(function() {
        console.log("failed in connecting to the signalr server");
      });

      fetch(Config.default.apiGateway.URL+'health_facilities',{ 
          method: 'get',
          headers: new Headers({
             'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
             'Accept': 'application/json',
              'Content-Type': 'application/json',
          })
      })
      .then(res => {
        if(res.ok){
            return res.json();
          }else{
            res.text().then(function(error) {
              swal('¡Error', error, 'error');
            });
        }
      })
      .then(response => {
          if(response !== undefined){
            this.setState({ sites: response });
          }
      })
  }

  setNewValues(counters,listOffers,listSV,listBiometrics,listExtractions,listAllSummary,listHC, today){
    
    switch(window.location.hash){
      case "#/offers":
        this.setState({ offers: {res:listAllSummary}});
      break;
      case "#/extractions":
        this.setState({ offers: {res:listExtractions}});
      break;
      case "#/register":
        this.setState({ offers: {res:listOffers}});
      break;
      case "#/vital_signs":
        this.setState({ offers: {res:listSV}});
      break;
      case "#/biometrics":
        this.setState({ offers: {res:listBiometrics}});
      break;
      case "#/clinic_history":
        this.setState({ offers: {res:listHC}});
      break;
    }
    this.setState({counters:counters, start_date:today, end_date:today});
  }

  handleChange(e){
    this.setState({
      [e.target.name]: e.target.value
    });

    var campo = e.target.name;
    setTimeout(()=>{
      if(campo !== 'site' && this.state.search !== 'extractions'){
        //this.getItems();
      }
      
    }, 500);
      
  }

  //Listado de registros
  getItems(filter){
    var type   = "";
    var search = "";
    var option = "";
    var all    = ""
    var url    = "";
    var extracion_filter = "";
    var site   = 'any';
    //var date   = this.state.date;

    filter !== undefined ? all = filter :
      this.state.allChecked ? all = 'all' : all = "";
    

    this.props.search ? 
      search = this.props.search : 
        search = this.props.match.url.replace('/', '');

    switch(search){
      case 'vital_signs':
        all === "" ? option = 'sv' : option = all;
        break;
      case 'offers':
        option = 'all-summary';
        site = this.state.site;
        break;
      case 'extractions':
        all === "" ? option = search : url = 'offers/all_extraction?date='+this.state.start_date;    

        extracion_filter = this.state.extracion_filter;   
        break;
      case 'register':
        //all === "" ? option = search : 
        option = 'all-register'; 
        break;
      case 'promotion/offers':
        all === "" ? option = 'campaings' : option = 'all-register' ;
        site = this.state.site === "" ? sessionStorage.getItems('health_facilities_id') : this.state.site;
        break;
      default:
        all === "" ? option = search : option = all;
        break;
    }
    
     /*search = search === 'vital_signs' ? 'sv' 
                : search === 'offers' ? 'all-summary' : search;

    console.log(search)
   
    search = (this.props.search === 'register' ||  this.props.match.url.replace('/', '') === 'register') && search === 'all' ?
                'all-register'
                : search;
    */
  
    
    if(this.state.start_date !== ""){
      if(url === ""){
        if(this.state.don_usr_llam.value === "NO_CALLER"){
          type = false;//CONFIGURACION SIN LLAMADOR    
        }else{
          type = true;//CONFIGURACION CON LLAMADOR
        }

        url = 'offers/get_list?date='+this.state.start_date+'&option='+option+'&health_facilities_id='+
              sessionStorage.getItem("health_facilities_id")+'&end_date='+this.state.end_date+'&filter='+extracion_filter+
              '&caller_option='+type+'&site='+site
      }
      
      if(this.waiting_modal !== null && this.waiting_modal !== undefined){  
        this.waiting_modal.handleShow('Cargando...');
      }

      if(this.state.show_promotion){
        url = 'offers/get_campaings?start_date='+this.state.start_date+'&end_date='+this.state.end_date+
              '&health_facilities_id='+site
      }
      //this.waiting_modal.handleShow('Cargando...');
      fetch(Config.default.apiGateway.URL+url,{ 
          method: 'get',
          headers: new Headers({
             'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
             'Accept': 'application/json',
              'Content-Type': 'application/json',
          })
      })
      .then(res => {
          if(this.waiting_modal !== null){  
            this.waiting_modal.handleClose();
          }
              if(res.ok){
                return res.json();
              }else{
                res.text().then(function(error) {
                  swal('¡Error', error, 'error');
                });
            }
      })
      .then(offers => {
          if(offers !== undefined){
            if(this.state.show_promotion){
              offers.res.map((r)=>{
                r.caller = null;
              });
            }
              
            if(this.state.show_promotion){
              offers.counters =  {
                total:offers.total,
                aptos:offers.aptos,
                no_aptos:offers.no_aptos,
                pending_hc:offers.pending_hc,
                with_bag:offers.with_bag,
                pending_ext:offers.pending_ext
              };
            }
            this.setState({ offers: offers,counters:offers.counters });
          }
      })
    }
  };

  createdRecord(){
    this.getItems();
    notify.show('Sus fichas han sido generadas','success');
  }

  clearedCaller(){
    this.modal_clear_caller.handleClose();
    this.getItems();
    swal('!Buen Trabajo', 'El listado se limpio correctamente', 'success');
  }

  selectFieldHandle = (event) => {
    this.setState({
        [event.target.name]: event.target.value
      });
    this.getItems(event.target.value);
  }

  handleUserInput(filterText) {
    this.setState({filterText: filterText});
  };

  dateHandleChange = (event) => {
    this.setState({
      [event.target.name]:event.target.value
    });
         
    /*if(this.state.search !== 'offers' && this.state.search !== 'extractions' && 
        this.state.search !== 'vital_signs' && this.state.search !== 'biometrics'&& 
        this.state.search !== 'clinic_history' &&
        !this.state.show_promotion){
      setTimeout(function() { //Start the timer
        if(this.state.allChecked){
          this.getItems('all');
        }else{
          this.getItems(); //After 1 second, set render to true  
        }
        
      }.bind(this), 100)
    }*/
  }

  newSingleRecord(){
    this.waiting_modal.handleShow('Generando...');
    var obj = {};
    obj.num_records = 1;
    obj.health_facilities_id = sessionStorage.getItem("health_facilities_id");
        fetch(Config.default.apiGateway.URL+'caller_actions_history', {
      method: 'POST', // or 'PUT',
      body: JSON.stringify(obj), // data can be `string` or {object}!
      headers: new Headers({
        'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      })
    }).then(res => {
      this.waiting_modal.handleClose();
      if(res.ok){
        return res.json();
      }else{
        res.text().then(function(result) {
          swal('¡Error!', result, 'error');
        });
      }})
    .then(response => {
        if(response !== undefined){
          this.getItems();
          notify.show('Ficha generada','success');
        }
    })
    .catch(function(error) {
      console.log('There has been a problem with your fetch operation: ' + error.message);
    });
  };

  newMultipleRecord(e){
    e.preventDefault();
    this.modal_multiple_records.handleShow();
  };

  /*LISTO*/
  getUsrLLam(){    
    fetch(Config.default.apiGateway.URL+'functional_criterion?code=don_usr_llam&x=',{ 
        method: 'get',
        headers: new Headers({
           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
           'Accept': 'application/json',
           'Content-Type': 'application/json',
        })
    })
    .then(response => response.json())
    .then(response => {
      this.setState({
          don_usr_llam: response
        });
      this.getItems();
    })
  }    

  componentDidUpdate() {
    if(this.props.search !== ''){
      
      if(this.props.search !== this.state.search){
        var aux_date = new Date();

        this.setState({
          search: this.props.search, //!== '' ? this.props.search : this.props.match.url.replace('/', '') ,
          allChecked:false,
          offers:[], 
          show_promotion:false,
          end_date: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
        });

        this.getUsrLLam()

        if(this.props.location.pathname.indexOf('promotion') !== -1){
          this.setState({show_promotion:true});
        }
      }  
    }
          
  }

  showAll(e){
    if(e.target.checked){
      this.setState({
        allChecked:true
      });
      setTimeout(()=>{
        this.getItems(this.state.filter);
      }, 500);
      
      
    }else{
      this.setState({
        allChecked:false
      });
      setTimeout(()=>{
        this.getItems();  
      })      
    }    
  }

  clearList(e){
    //MOSTRAR MODAL PARA SELECCIONAR OPCIÓN
    e.preventDefault();
    this.modal_clear_caller.handleShow();
  }

  onSearch(){
    this.getItems();
  }

  newOffer(e){
    e.preventDefault();
    this.props.history.push('offers/new/0');
  }

  //Contenido de la pantalla Listado
  render() {
    const { t } = this.props;
    var submenu = this.props.search !== "" ? 
                    this.props.search !== 'all' ? 
                      this.props.search === this.props.match.url.replace('/', '') ?
                        this.props.search
                      :this.props.match.url.replace('/', '')
                    : this.props.match.url.replace('/', '')
                  : this.props.match.url.replace('/', '');
    var session = sessionStorage.getItem('health_facilities_name');
    var matriz = sessionStorage.getItem('matriz');



    return (
      <div className="col-xs-12">
        <div className="route">
          <h5 className="title_page" >
            {session} ->
            {t('sidebar.nav.donors.MAIN')} -> 
            {this.state.show_promotion ? 'Promoción' :t('sidebar.nav.donors.'+submenu )}
          </h5>
        </div>

        <Help
            {...this.props}
            menu={"help_donors"} 
            submenu={this.state.help_submenu}  />

        
        

        <div className="form-group">
          <div className="col-xs-12 form-group">          
            {submenu === 'offers' && matriz === '1' || this.state.show_promotion?
              <div className="col-xs-12 col-md-2">
                  <span className="span-min">Sitio</span>
                  <select className="form-control" name="site" id="site" value={this.state.site || ""}
                    onChange={this.handleChange}>
                    <option value="any">Seleccionar...</option>
                    <option value="all">Todos</option>
                    {this.state.sites.map((s, i)=>(
                      <option key={i} value={s.id}>{s.name}</option>
                    ))}
                  </select>
              </div>
            :null}
          
            <div className="col-xs-12 col-md-3" style={{width:'10%'}}>
              <span className="span-min">{t('content.offers.form.show_from')+':'}</span>
              <input className="form-control hour-input" type="date" name="start_date" value={this.state.start_date}
                onChange={ (e) => this.dateHandleChange(e)}/>
            </div>

            <div className="col-xs-12 col-md-3" style={{width:'10%'}}>
              <span className="span-min">{t('content.offers.form.show_to')+':'}</span>
              <input className="form-control hour-input" type="date" name="end_date" value={this.state.end_date}
              onChange={ (e) => this.dateHandleChange(e)}/>
            </div>

            {submenu === 'extractions' ?
              <div className="col-xs-12 col-md-2">
                  <span className="span-min">{'Estatus:'}</span>
                  <select className="form-control" name="extracion_filter" id="extracion_filter" value={this.state.extracion_filter || ""}
                    onChange={this.handleChange}>
                    <option value="with_extraction">Con Extracción</option>
                    <option value="pending">Pendientes</option>
                    <option value="all">Todos</option>
                  </select>
              </div>
            :null}
         
            <div className={submenu === 'promotion/offers'? "col-xs-12 col-md-2" : "col-xs-12 col-md-1"} style={{marginTop:'18px'}}>
              <button style={{fontSize:"15px", paddingTop:'1px', paddingBottom:'1px', marginRight:'8px'}} className="btn btn-info btn-search" type="button"
                onClick={this.onSearch}>
                <SvgIcon icon={search}/> | Buscar
              </button>
              {submenu === 'promotion/offers'?
                this.props.task_summary_campaigns.create ? 
                  <button type="button" className="btn btn-info btn-search" onClick={(e)=>this.newOffer(e)}>
                    NUEVO
                  </button>
                :null
              :null}
            </div>
          {submenu === 'register' ?
            <div className="col-xs-12 col-md-3" style={{marginTop:'18px'}}>
                {this.state.don_usr_llam.value === "PRE_CALLER" && !this.state.no_caller?
                  <div style={{display:'inline-block'}}>

                    <button onClick={(e) => this.newMultipleRecord(e)} 
                      /*disabled={submenu === 'register' ? !this.props.task_register.create :
                                  !this.props.task_general_summary.create}*/
                      disabled={!this.props.task_screen_caller.create}
                      className="btn btn-info" style={{fontSize:".7em", marginRight:"8px"}} 
                      type="button">GENERAR FICHAS</button>

                    <button onClick={(e) => this.clearList(e)} 
                      /*disabled={submenu === 'register' ? !this.props.task_register.delete :
                                  !this.props.task_general_summary.delete}*/
                      style={{marginRight:"8px"}}
                      disabled={!this.props.task_screen_caller.delete}
                      className="btn btn-info btn-search" type="button">LIMPIAR LISTADO</button>
                  </div>
                  :null
                }
                {this.state.don_usr_llam.value === "AUT_CALLER" && !this.state.no_caller?
                  <div>
                    <button onClick={this.newSingleRecord} 
                      /*disabled={submenu === 'register' ? !this.props.task_register.create :
                                  !this.props.task_general_summary.create}*/
                      disabled={!this.props.task_screen_caller.create}
                      className="btn btn-info btn-search" style={{fontSize:".7em", marginRight:"8px"}} 
                      type="button">SACAR FICHA</button>

                    <button onClick={this.clearList} 
                      /*disabled={submenu === 'register' ? !this.props.task_register.delete :
                                  !this.props.task_general_summary.delete}*/
                      style={{marginRight:"8px"}}
                      disabled={!this.props.task_screen_caller.delete}
                      className="btn btn-info btn-search" type="button">LIMPIAR LISTADO</button>
                  </div>
                  :null
                }
                {this.props.task_register.create ? 
                  this.state.don_usr_llam.value === "NO_CALLER" || this.state.no_caller?
                    <button type="button" className="btn btn-info btn-search" onClick={(e)=>this.newOffer(e)}>
                      NUEVO
                    </button>
                  :null
                :null}
            </div>
          : null}
            
          </div>
        </div> 
        <div className="col-xs-12 form-group">
          <div className="col-xs-12 col-md-2" style={{width:'16.5%', marginTop:'7px'}}>
            <SearchBar filterText={this.state.filterText} onUserInput={this.handleUserInput.bind(this)}/>
          </div>
          {submenu !== 'offers' && submenu !== 'register' && submenu !== 'extractions' && !this.state.show_promotion?
            <div className="col-xs-12 col-md-1" style={{marginTop:'7px'}}>
                <label style={{margonBottom:"0px", marginTop:"3px"}}> Ver todos <input type="checkbox" checked={this.state.allChecked} onChange={this.showAll} />
                </label>
            </div>
          :null
          }
          <div className="col-xs-12 col-sm-8" style={{textAlign:'center', padding:'0'}}>
              <span className="title-result-stats" style={{marginLeft:"10px"}}>Total: </span> 
              <span style={{marginRight:"10px"}} className="result-stats">
                {this.state.counters.total !== undefined ? '  '+this.state.counters.total : ''}</span>
              
              <span className="title-result-stats">Aptos: </span> 
              <span style={{marginRight:"10px"}} className="result-stats">
                {this.state.counters.aptos !== undefined ? '  '+this.state.counters.aptos : ''}</span>
              
              <span className="title-result-stats">No Aptos: </span>
              <span style={{marginRight:"10px"}} className="result-stats">
                {this.state.counters.no_aptos !== undefined ? '  '+this.state.counters.no_aptos : ''}</span>
              
              <span className="title-result-stats">Pendientes HC: </span>
              <span style={{marginRight:"10px"}} className="result-stats">
                {this.state.counters.pending_hc !== undefined ? '  '+this.state.counters.pending_hc : ''}</span>
              
              <span className="title-result-stats">Con bolsa: </span>
              <span style={{marginRight:"10px"}} className="result-stats">
                {this.state.counters.with_bag !== undefined ? '  '+this.state.counters.with_bag : ''}</span>

              <span className="title-result-stats">Pendientes Ext: </span>
              <span style={{marginRight:"10px"}} className="result-stats">
                {this.state.counters.pending_ext !== undefined ? '  '+this.state.counters.pending_ext : ''}</span>
            </div>
        </div>
        <div className="col-xs-12">
            <TableOffers filterDate={this.state.date} filterText={this.state.filterText} {...this.props} onRef={ref => (this.table = ref)} 
              offers={this.state.offers} 
              search={this.props.search} 
              refresh={this.getItems}
              state={this.state}
              />
        </div>
        <ModalMultipleRecords {...this.props} onRef={ref => (this.modal_multiple_records = ref)} refresh={this.createdRecord}/>
        <ModalClearCaller {...this.props} onRef={ref => (this.modal_clear_caller = ref)}  refresh={this.clearedCaller}/>
        <Notifications />
        <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
      </div>
    );
  }
}

export default translate('translations')(Offers)